import React, {useState} from 'react';
import styles from './NewPassword.module.css';
import globalStyles from '../../styles/globalStyles.module.css';
import forgotPassword from '../../assets/images/forgotPassword.svg';
import {IoEyeOutline, IoEyeOffOutline} from "react-icons/io5";
import {useNavigate, useLocation} from 'react-router-dom';
import {postFetcher} from '../../../api/fetchers';
import {endpoints} from '../../../api/endpoints';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLanguage } from '../../context/LanguageContext';

const NewPassword: React.FC = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const {email, verificationCode} = location.state || {};
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Password validation
        if (newPassword !== confirmPassword) {
            setError('Şifreler aynı değil.');
            return;
        }
        if (newPassword.length < 8 || !/[A-Z]/.test(newPassword)) {
            setError('Şifre en az 8 karakter uzunluğunda ve en az bir büyük harf içermelidir.');
            return;
        }

        try {
            const result = await postFetcher(endpoints.auth.changeUserPassword, {
                arg: {
                    email: email,
                    newPassword: newPassword,
                    verificationCode: verificationCode

                }
            });

            if (result && result.message === 'Password changed successfully') {
                toast.success(t('toastMessage', 'infoSuc'));
                setTimeout(() => {
                    navigate('/');
                }, 2000);
            } else {
                toast.error(t('toastMessage', 'infoErr'));
                setError('Şifre değiştirilirken bir hata oluştu.');
            }
        } catch (error) {
            console.error('Error changing password:', error);
            setError('Bir hata oluştu, lütfen tekrar deneyin.');
        }
    };

    return (
        <div className="flex flex-col md:flex-row h-screen w-screen bg-primary-color">
            <ToastContainer/>
            {/* LEFT SIDE */}
            <div className={`w-full md:w-1/2 flex items-center justify-center ${globalStyles.leftSide} hidden md:flex`}>
                <img src={forgotPassword} alt="Forgot Password Illustration" className="object-cover"/>
            </div>
            {/* RIGHT SIDE */}
            <div
                className={`w-full md:w-1/2 h-full bg-white flex items-center justify-center ${globalStyles.rightSide}`}>
                <div className="w-full max-w-md p-8 space-y-8">
                    {/* NEW PASSWORD FORM */}
                    <h1 className={`w-full text-5xl text-center text-color-pink mb-10 ${globalStyles['poppins-regular']}`}>Yeni
                        Şifre</h1>

                    {error && (
                        <div className="text-red-500 text-center mb-4">
                            {error}
                        </div>
                    )}

                    <form className="space-y-8" onSubmit={handleSubmit}>
                        {/* PASSWORD INPUT */}
                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="newPassword"
                                name="newPassword"
                                placeholder="Şifre"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className={`block w-full py-2 mt-1 bg-transparent border-b-2 border-color-pink placeholder-color-pink placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {showPassword ? (
                                <IoEyeOffOutline
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-color-pink text-xl"
                                    onClick={() => setShowPassword(false)}
                                />
                            ) : (
                                <IoEyeOutline
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-color-pink text-xl"
                                    onClick={() => setShowPassword(true)}
                                />
                            )}
                        </div>

                        {/* CONFIRM PASSWORD INPUT */}
                        <div className="relative">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Şifre Yeniden"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className={`block w-full py-2 mt-1 bg-transparent border-b-2 border-color-pink placeholder-color-pink placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                            {showConfirmPassword ? (
                                <IoEyeOffOutline
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-color-pink text-xl"
                                    onClick={() => setShowConfirmPassword(false)}
                                />
                            ) : (
                                <IoEyeOutline
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-color-pink text-xl"
                                    onClick={() => setShowConfirmPassword(true)}
                                />
                            )}
                        </div>

                        {/* SUBMIT BUTTON */}
                        <button
                            type="submit"
                            className="w-full px-4 py-2 text-primary-color bg-color-pink font-bold rounded-md hover:bg-hover-color hover:text-color-pink focus:ring-2 focus:ring-pink-500"
                        >
                            Kaydet
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default NewPassword;
